import { render, staticRenderFns } from "./Advisory.vue?vue&type=template&id=a2c61456&scoped=true"
import script from "./Advisory.vue?vue&type=script&lang=js"
export * from "./Advisory.vue?vue&type=script&lang=js"
import style0 from "./Advisory.vue?vue&type=style&index=0&id=a2c61456&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c61456",
  null
  
)

export default component.exports